<template>
  <v-card>
    <v-container class="pb-0 pt-2 mobile-container">
      <v-card-actions class="pb-4 pt-0">
        <span class="text-h5 pl-1">Importación de médicos emisores</span>
        <v-spacer></v-spacer>
        <v-tooltip text="Cerrar" location="left">
          <template v-slot:activator="{ props }">
            <v-btn
              color="primary"
              v-bind="props"
              class="to-right"
              :icon="closeIcon"
              id="v-btn-close-importar-medicos-emisores"
              @click="closeModal"
            >
            </v-btn>
          </template>
        </v-tooltip>
      </v-card-actions>
      <v-card-text class="px-0">
        <v-row>
          <v-col cols="12" class="px-2">
            <v-file-input ref="file" v-model="file" :disabled="loading" :loading="loading"
              id="file-input-excel-medicos-emisores" type="file" dense variant="underlined" label="Excel"
              placeholder="Seleccionar el archivo Excel" accept=".xls,.xlsx,.csv" outlined @change="importExcel"
              @click:clear="clearExcelFile" prepend-icon="mdi-paperclip">
            </v-file-input>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="pb-3 pr-0">
        <v-btn
          color="success"
          variant="text"
          @click="openFormatoModal"
          id="v-btn-ver-formato-medicos-emisores"
        >
          Ver formato
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" variant="flat" type="submit" :disabled="!enableProcess || !file" :loading="loadingBtn"
          form="submit-form" @click="saveFileData" id="v-btn-importar-medicos-emisores">
          Importar
        </v-btn>
      </v-card-actions>
    </v-container>
  </v-card>
  <v-dialog
    v-if="openModalFormatoImportacion"
    v-model="openModalFormatoImportacion"
    :max-width="isMobile ? '95%' : '65%'"
    persistent
  >
    <VerFormatoImportaciones
      tipoEntidad="Medico emisor"
      @closeDialog="closeFormatoModal"
    />
  </v-dialog>
</template>

<script>
import helpersExcel from "@/utils/helpers/importExportExcel.js";
import { mapActions, mapGetters } from "vuex";
import enums from "@/utils/enums";
import VerFormatoImportaciones from "@/components/shared/VerFormatoImportaciones.vue";

export default {
  name: "ImportarMedicosEmisores",
  components: {
    VerFormatoImportaciones,
  },
  props: {
    financiadorId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      isMobile: "menu/isMobile",
    }),
  },
  data() {
    return {
      loading: false,
      file: null,
      excelData: [],
      fileName: "",
      fileDataTranslated: [],
      loadingBtn: false,
      enableProcess: false,
      openModalFormatoImportacion: false,
      expectedHeaders: [
        "Nombre",
        "Tipo documento",
        "Numero documento",
        "Cuit",
        "Tipo prestador",
        "Matricula",
        "Provincia",
        "Direccion",
        "Telefono",
        "Sexo",
        "Email",
        "Deshabilitado",
      ],
      errores: [],
      closeIcon: enums.icons.CLOSE_ICON,
    };
  },
  methods: {

    ...mapActions({
      setAlert: "user/setAlert",
      saveImportacionMedicosEmisores:
        "usuariosEmisores/saveImportacionMedicosEmisores",
    }),
    clearExcelFile() {
      this.fileDataTranslated = [];
      this.excelData = [];
    },
    async importExcel() {
      try {
        this.loading = true;
        this.excelData = [];
        this.fileDataTranslated = [];
        
        // Capturar el nombre del archivo
        this.fileName = this.file ? this.file.name : "";
        
        await this.getArchivo();

        if (!this.hasValidData()) {
          this.setAlert({
            type: "warning",
            message: "Archivo inválido. ",
          });
          return;
        }

        const validHeaders = helpersExcel.validarCabecerasExcel(
          this.file,
          this.expectedHeaders
        );
        if (!validHeaders) {
          this.resetFileInput();
          return;
        }
        this.excelData[0].filas.forEach((x) => {
          this.fileDataTranslated.push({
            nombre: x["NOMBRE"]?.toString()?.trim() ?? "",
            tipoDoc: x["TIPO DOCUMENTO"]?.toString()?.trim() ?? "",
            nroDoc: x["NUMERO DOCUMENTO"]?.toString()?.trim() ?? "",
            cuit: x["CUIT"]?.toString().trim() ?? "",
            tipoPrestador: typeof x["TIPO PRESTADOR"] == "object"
              ? x["TIPO PRESTADOR"].text?.toString().trim()
              : x["TIPO PRESTADOR"]?.toString().trim() ?? "",
            matricula: x["MATRICULA"]?.toString()?.trim() ?? "",
            provincia: x["PROVINCIA"]?.toString()?.trim() ?? "",
            direccion: x["DIRECCION"]?.toString()?.trim() ?? "",
            telefono: x["TELEFONO"]?.toString()?.trim() ?? "",
            sexo: x["SEXO"]?.toString()?.trim()?.toUpperCase() ?? "",
            email:
              typeof x["EMAIL"] == "object"
                ? x["EMAIL"].text?.toString().trim()
                : x["EMAIL"]?.toString().trim() ?? "",
            deshabilitado:
              x["DESHABILITADO"]?.toString().trim().toUpperCase() == "SI"
                ? true
                : false ?? "",
          });
        });

        this.enableProcess = true;
      } catch (error) {
        console.error("Error al importar el archivo:", error);
        this.resetFileInput();
      } finally {
        this.loading = false;
      }
    },
    async saveFileData() {
      this.loadingBtn = true;
      const data = {
        financiadorId: this.financiadorId,
        fileData: this.fileDataTranslated,
        nombreArchivo: this.fileName,
      };
      try {
        const response = await this.saveImportacionMedicosEmisores(data);
        if (response.status == 200) {
          if (response.data.length > 0) {
            this.errores = response.data;
            this.setAlert({
              type: "warning",
              message: "Existen datos con errores. ",
            });
            this.exportErrors();
          } else {
            this.setAlert({
              type: "success",
              message: "Datos importados con éxito. ",
            });
          }
        }
      } catch (error) {
        this.setAlert({
          type: "error",
          message: `Error al importar entidades emisoras: ${error}`,
        });
        this.resetFileInput();
      }
      this.closeModal();
      this.reloadMedicosEmisores();
      this.loadingBtn = false;
    },
    exportErrors() {
      let result = [];
      this.errores.forEach((x) => {
        result.push({
          ["Nombre"]: x.nombre ?? "",
          ["Tipo documento"]: x.tipoDoc ?? "",
          ["Numero documento"]: x.nroDoc ?? "",
          ["CUIT"]: x.cuit ?? "",
          ["Tipo prestador"]: x.tipoPrestador ?? "",
          ["Matricula"]: x.matricula ?? "",
          ["Provincia"]: x.provincia ?? "",
          ["Direccion"]: x.direccion ?? "",
          ["Telefono"]: x.telefono ?? "",
          ["Sexo"]: x.sexo ?? "",
          ["Email"]: x.email ?? "",
          ["Deshabilitado"]: x.deshabilitado ? "SI" : "NO",
          ["Errores"]: x.errores,
        });
      });

      let formato = {
        filas: result,
        hoja: "Errores importación",
      };
      helpersExcel.excelExport(formato, "Errores importación médicos emisores");
    },
    hasValidData() {
      return (
        this.excelData == undefined || !!this.excelData?.[0]?.filas?.length
      );
    },
    async getArchivo() {
      this.$refs["file"].validate(true);

      if (this.$refs.file.validate())
        this.excelData = await helpersExcel.excelImport(this.file, 0);
      else throw new Error("Archivo inválido");
    },
    resetFileInput() {
      this.$refs["file"].reset();
      this.file = null;
      this.fileName = "";
      this.fileDataTranslated = this.excelData = [];
      this.enableProcess = this.loading = false;
      return;
    },
    closeModal() {
      this.$emit("closeDialog");
    },
    reloadMedicosEmisores() {
      this.$emit("reloadMedicosEmisores");
    },
    openFormatoModal() {
      this.openModalFormatoImportacion = true;
    },
    closeFormatoModal() {
      this.openModalFormatoImportacion = false;
    },
  },
};
</script>